import React from 'react';
import styles from './Footer.module.css';

const Footer = () => {
  return (
    <footer className={styles.footer}>
      <div className={styles.innerContainer}>
        <div className={styles.logoSection}>
            <a href="/">
                <img
                    src="/assets/loggableLogos/LoggableIconHorizontal.png"
                    alt="Loggable Logo"
                    className={styles.logo}
                />
            </a>
            <p className={styles.tagline}>Digitize. Export. Log Smarter.</p>
        </div>
        <div className={styles.linksSection}>
          <a href="/privacy" className={styles.link}>Privacy Policy</a>
          <a href="/terms" className={styles.link}>Terms of Service</a>
          <a href="/eula" className={styles.link}>Terms of Use</a>
          <a href="/support" className={styles.link}>Contact Support</a>
        </div>
      </div>
      <div className={styles.bottomBar}>
        &copy; {new Date().getFullYear()} Loggable LLC. All rights reserved.
      </div>
    </footer>
  );
};

export default Footer;
